export default () => ({
  isSavingShare: false,
  /** @type {import('src/types/shares-store').LocationShare[]} */
  shares: [],
  sharesLoading: false,
});
